import { createQueryKeys } from '@lukemorales/query-key-factory';
import { ModuleService } from '../service/service';
export const modulesQueries = createQueryKeys('modules', {
    listClassDrippingStatus: (moduleId) => ({
        queryKey: [moduleId],
        queryFn: () => ModuleService.getClassDrippingStatus(moduleId)
    }),
    byId: (moduleId) => ({
        queryKey: [moduleId],
        queryFn: () => ModuleService.getModule(moduleId)
    })
});
